<template>
  <v-card>
    <v-card-title class="py-3 px-4 border-bottom">
      <span class="gray--text text--darken-3 font-weight-regular">
        {{ isEditMode ? "Ölçünün redaktəsi" : "Yeni ölçü" }}
      </span>
    </v-card-title>
    <v-card-text>
      <v-form
        id="createSizeForm"
        ref="form"
        v-model="formValidation"
        lazy-validation
        @submit.prevent="handleFormSubmit"
      >
        <v-row>
          <v-col cols="12">
            <v-text-field
              type="text"
              label="Adı"
              filled
              dense
              v-model="formData.name"
              :rules="formRules.name"
              required
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <v-textarea
              type="text"
              label="Təsviri"
              filled
              dense
              auto-grow
              rows="1"
              v-model="formData.description"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions class="py-3 px-4 d-flex justify-end border-top">
      <v-btn color="gray lighten-3" depressed @click="toggleDialog">
        Bağla
      </v-btn>
      <v-btn
        :loading="isSubmittingForm"
        type="submit"
        form="createSizeForm"
        color="success"
        depressed
      >
        {{ isEditMode ? "Yadda saxla" : "Yarat" }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    toggleDialog: {
      type: Function,
      required: true,
    },
    isSubmittingForm: {
      type: Boolean,
      required: true,
    },
    selectedSize: {
      type: Object,
      required: false,
      default: () => null,
    },
  },
  data() {
    return {
      formValidation: false,
      formData: {
        name: "",
        description: "",
      },
      formRules: {
        name: [(v) => !!v || "Ölçü adını daxil edin"],
      },
    };
  },
  computed: {
    isEditMode() {
      return (
        this.selectedSize && this.selectedSize.id && this.selectedSize.id > 0
      );
    },
  },
  watch: {
    selectedSize: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.formData = { ...newVal };
        } else {
          this.resetFormData();
        }
      },
    },
  },
  methods: {
    handleFormSubmit() {
      const isFormValid = this.$refs.form.validate();
      if (isFormValid) {
        this.$emit("formSubmit", this.formData);
      }
    },
    resetFormData() {
      this.formData = {
        name: "",
        description: "",
      };
      this.$refs.form && this.$refs.form.resetValidation();
    },
  },
};
</script>
